import { TypePolicies } from '@apollo/client'

export const jobCatalogTypePolicies: TypePolicies = {
  JobCatalogTreeNode: {
    keyFields: ['uuid'],
  },
}
